// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__ojgP5","spinner":"Spinner_spinner__pksHY","spinner-aib1d7":"Spinner_spinner-aib1d7__bw9bz"};